import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { FindingCategory } from "./Finding";

// Названия строк «светофора». `Record` по union из контракта: новая категория не соберётся без перевода.
export const CATEGORY_LABELS: Record<FindingCategory, MessageDescriptor> = {
  buy: msg({ id: "analysis.category.buy", message: "Buying" }),
  farm: msg({ id: "analysis.category.farm", message: "Farm and lane" }),
  deaths: msg({ id: "analysis.category.deaths", message: "Deaths" }),
  fights: msg({ id: "analysis.category.fights", message: "Fights" }),
  skills: msg({ id: "analysis.category.skills", message: "Abilities" }),
};
